import { useEffect, useRef } from 'react';

/**
 * Attaches an IntersectionObserver to all `.reveal` elements
 * within the given container ref. Once revealed, elements are
 * unobserved so the animation never re-triggers.
 */
export default function useScrollReveal(deps = []) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    // Observe all .reveal elements inside the container
    const targets = container.querySelectorAll('.reveal');
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  // eslint-disable-next-line
  }, deps);

  return containerRef;
}
